import { render, staticRenderFns } from "./SecondVoice.container.vue?vue&type=template&id=120db5ac&scoped=true&"
import script from "./SecondVoice.container.vue?vue&type=script&lang=js&"
export * from "./SecondVoice.container.vue?vue&type=script&lang=js&"
import style0 from "./SecondVoice.container.vue?vue&type=style&index=0&id=120db5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120db5ac",
  null
  
)

export default component.exports